import { render, staticRenderFns } from "./BrandS.vue?vue&type=template&id=4b70b8d1&scoped=true&"
import script from "./BrandS.vue?vue&type=script&lang=js&"
export * from "./BrandS.vue?vue&type=script&lang=js&"
import style0 from "./BrandS.vue?vue&type=style&index=0&id=4b70b8d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70b8d1",
  null
  
)

export default component.exports